import { SxProps, Theme } from '@mui/material';

export const tableScrollbarStyles: SxProps<Theme> = {
    '&::-webkit-scrollbar': { width: 10, height: 10 },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(255,255,255,0.3)',
        borderRadius: 1,
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(0,0,0,0.2)',
    },
};
